import React, { createContext, ReactNode, useContext, useState } from 'react';
import { Loading } from '../shared/components';
interface LoadingContextProps {
  loading: boolean;
  showLoading: () => void;
  hideLoading: () => void;
}
const LoadingContext = createContext<LoadingContextProps>(
  {} as LoadingContextProps,
);

// Export the provider as we need to wrap the entire app with it
export function LoadingProvider({ children }: { children: ReactNode }) {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <LoadingContext.Provider
      value={{
        loading,
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
      }}
    >
      {children}
      {loading && <Loading />}
      
    </LoadingContext.Provider>
  );
}

// Let's only export the `useAuth` hook instead of the context.
// We only want to use the hook directly and never the context component.
export default function useGlobalLoading() {
  return useContext(LoadingContext);
}
